import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { Tag } from 'antd';
import "antd/dist/antd.min.css";
import GetFilterCountries from './GetFilterCountries';

function SeacrhFilter({ searchCountry, getProducts, isFetching }) {
  const { t } = useTranslation()
  const location = useLocation();
  const searchThisCountry = new URLSearchParams(location.search).get('country') || null
  const thisCountry = searchThisCountry ? `&country=${searchThisCountry}` : ''
  const [getFeaturesLength, setFeaturesLength] = useState(false);
  const uniqueBrands = [...new Set(getProducts?.map(p => p.brand))];
  const pathName = window.location.pathname?.split('/')

  return (
    <div className="col-md-2 mob-w100" style={{ padding: '5px' }}>

      <div style={{ height: '100%', marginTop: '10px', filter: isFetching ? 'opacity(0.5)' : 'opacity(1)' }}>
        <div style={{ marginBottom: '15px' }}>
          <div style={{ fontSize: '0.9rem', fontWeight: 500 }}>{t('countries')}</div>
          <GetFilterCountries searchCountry={searchCountry} isFetching={isFetching} />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <div style={{ fontSize: '0.9rem', fontWeight: 500, marginTop: '10px' }}>{t('deals_discount')}</div>
          <Link disabled={isFetching} to="/store/deals">
            <Tag
              className='tag-hover badge badge-light'
              style={{ fontWeight: 500, marginBottom: '5px', border: '1px solid #2f122e54', textAlign: 'start' }}
            >
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <span>Deals Upto 50% Off</span>
              </span>
            </Tag>
          </Link>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <div style={{ fontSize: '0.9rem', fontWeight: 500, marginTop: '10px' }}>{t('other_categories')}</div>
          <Link to="/search/toys" className="side-menu-item-search">Toys</Link>
          <Link to="/search/fashion" className="side-menu-item-search">Fashion</Link>
          <Link to="/search/gaming console" className="side-menu-item-search">Gaming & Console</Link>
          <Link to="/search/headphones" className="side-menu-item-search">Headphones</Link>
          <Link to="/search/accessories" className="side-menu-item-search">Accessories</Link>
          <Link to="/search/Gift sets" className="side-menu-item-search">Gift sets</Link>
          <Link to="/search/Mens Grooming" className="side-menu-item-search">Mens Grooming</Link>
          <Link to="/search/musical instrument" className="side-menu-item-search">Musical Instrument</Link>
          <Link to="/search/laptops" className="side-menu-item-search">Laptops</Link>
          <Link to="/search/phones" className="side-menu-item-search">Phones</Link>
        </div>

        {uniqueBrands?.length > 1 &&
          <div style={{ marginBottom: '15px' }}>
            <div style={{ fontSize: '0.8rem', fontWeight: 500, marginTop: '10px' }}>Brands</div>
            {uniqueBrands?.slice(0, getFeaturesLength ? 100 : 8)?.map((item, i) => item &&
              <Link to={pathName?.includes('search') ? `/search/${item}` : `${window.location.pathname}?brand=${item}${thisCountry}`}>
                <Tag className='tag-hover badge badge-light' style={{ fontWeight: 500 }}>{item}</Tag>
              </Link>
            )}

            {uniqueBrands?.length > 8 &&
              <Link
                to={`#`}
                onClick={(() => setFeaturesLength(getFeaturesLength ? false : true))}
                style={{ cursor: 'pointer', fontSize: '11px', whiteSpace: 'nowrap', fontWeight: 500 }}>
                {getFeaturesLength ? t('show_less') : t('show_more')}
              </Link>
            }
          </div>
        }

      </div>
    </div>
  );
}

export default SeacrhFilter;
